import { gql } from "@apollo/client";

export const UPDATE_PACKAGE_MUTATION = gql`
  mutation UpdatePackage($id: Int!, $packageData: PackageInput!) {
    updatePackage(id: $id, packageData: $packageData) {
      package {
        id
        name
        price
        limitMamps
        limitDailywh
        resetTime
      }
    }
  }
`;
